import {
  Dialog, DialogContent, DialogHeader, DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Download, Upload, Loader2 } from "lucide-react";

/**
 * Bulk-upload dealers via CSV. Parent controls open state and receives
 * file/submit callbacks.
 *
 * Props:
 *  - open, onOpenChange
 *  - submitting            (while upload is in flight)
 *  - onDownloadSample()    triggers sample CSV download
 *  - onFileSelected(e)     receives change event from the hidden file input
 */
export function BulkUploadDealersDialog({
  open,
  onOpenChange,
  submitting,
  onDownloadSample,
  onFileSelected,
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle className="font-heading text-navy">Bulk Upload Dealers</DialogTitle>
        </DialogHeader>
        <div className="space-y-4">
          <p className="text-sm text-slate-600 font-body">
            Upload a CSV with columns:{" "}
            <code className="bg-slate-100 px-1 rounded text-xs">
              first_name, last_name, email, phone, company_name, address, city, state, zip_code, password
            </code>
          </p>
          <Button
            variant="outline"
            size="sm"
            onClick={onDownloadSample}
            className="w-full"
            data-testid="download-sample-dealers-csv"
          >
            <Download className="w-4 h-4 mr-2" />Download Sample CSV
          </Button>
          <div className="border-2 border-dashed border-slate-300 rounded-lg p-6 text-center">
            <input
              type="file"
              accept=".csv"
              onChange={onFileSelected}
              className="hidden"
              id="bulk-dealer-upload"
              data-testid="bulk-dealer-file-input"
            />
            <label htmlFor="bulk-dealer-upload" className="cursor-pointer">
              {submitting ? (
                <Loader2 className="w-8 h-8 animate-spin text-teal mx-auto" />
              ) : (
                <>
                  <Upload className="w-8 h-8 text-slate-400 mx-auto mb-2" />
                  <p className="text-sm text-slate-600 font-body">Click to upload CSV</p>
                </>
              )}
            </label>
          </div>
          <p className="text-xs text-slate-400">
            If password column is empty, default password &quot;dealer123&quot; will be used.
          </p>
        </div>
      </DialogContent>
    </Dialog>
  );
}
